'use client';
import { FormInstance } from 'antd';
import React from 'react';
import Step1Content from './Step1';
import Step2Content from './Step2';
import Step3Content from './Step3';
import Step4Content from './Step4';
import Step5Content from './Step5';
import { Step1SessionData } from './types';
import { StepItem } from '@/components/common/form/MultiStepForm';

export function getSignupSteps(
  form: FormInstance,
  step1Data?: Step1SessionData | null,
  inlineError?: string | null
): (StepItem | undefined)[] {
  return [
    {
      id: 'account_type',
      title: 'Account Creation',
      subtitle: 'Step 1: Choose account type',
      description: 'Select the type of account you want to create.',
      hasFormFields: true,
      validation: ['account_type', 'individual_subtype', 'agree'],
      content: <Step1Content form={form} inlineError={inlineError} />,
    },
    {
      id: 'identification',
      title: 'Account Creation',
      subtitle: 'Step 2: Identification details',
      description: 'As they appear in official registration documents.',
      hasFormFields: true,
      validation: ['id_number', 'kra_pin', 'last_name'],
      content: (
        <Step2Content
          form={form}
          sessionId={step1Data?.session_id}
          errorProp={inlineError}
        />
      ),
    },
    {
      id: 'contact_info',
      title: 'Account Creation',
      subtitle: 'Step 3: Contact Information',
      description: 'Where a verification code will be sent',
      hasFormFields: true,
      validation: ['email', 'phone'],
      content: <Step3Content form={form} />,
    },
    {
      id: 'verify_otp',
      title: 'Account Creation',
      subtitle: 'Step 4: Verify OTP',
      description:
        ' Input the one-time verification code sent to your contact details.',
      hasFormFields: true,
      validation: ['otp'],
      content: <Step4Content form={form} />,
    },
    {
      id: 'set_password',
      title: 'Account Creation',
      subtitle: 'Step 5: Set your password',
      description: ' Create a secure password for your account.',
      hasFormFields: true,
      validation: ['password', 'confirm_password'],
      content: <Step5Content form={form} />,
    },
    {
      id: 'success',
      title: 'Account Creation',
      subtitle: 'Step 6: Success',
      hasFormFields: false,
      content: (
        <>
          <h4 className="font-semibold">Account created successfully</h4>
          <p>You can now access your account by signing into the portal.</p>
        </>
      ),
      prevText: 'Go to Home Page', // overrides the back button text
      nextText: 'Go to My Account', // overrides the next button text
      submitText: 'Go to My Account', // ← add this
    },
  ];
}

